import { bootHomeV2Firebase } from './facade'

declare global {
  interface Window {
    __benjarukHomeV2FirebaseBooted?: boolean
  }
}

;(async function boot() {
  if (window.__benjarukHomeV2FirebaseBooted) return
  window.__benjarukHomeV2FirebaseBooted = true
  try {
    await bootHomeV2Firebase()
    try {
      document.dispatchEvent(new CustomEvent('benjaruk-firebase-home-v2-ready'))
    } catch {
      /* ignore */
    }
  } catch (e) {
    console.error('[home-v2] bootstrap failed', e)
    window.__benjarukHomeV2FirebaseBooted = false
  }
})()
